import { Form, Row, Col, Button} from "react-bootstrap"
import BreadcrumbDatos from "./BreadcrumbDatos";
import { useNavigate, useParams, useSearchParams } from "react-router-dom"
import { useState, useEffect } from "react";
import EstadoSelect from "../common/EstadoSelect";
import { Controller, useForm } from "react-hook-form";
import { nuevoProducto, editarProducto, getProducto } from "../../services/ProductosService";
import { getMarcas } from "../../services/MarcasService";
import ErrorMessages from "../common/ErrorMessages";
import { Cargando } from "../common/Cargando";

export default function ProductosForm() {

    /*
    https://www.react-hook-form.com/get-started/
    */

    const {id} = useParams();
    const [params, setSearchParams] = useSearchParams()

    const marca_id = params.get('marca')

    const navigate = useNavigate();

    const [errores, setErrores] = useState([]);
    const [marca, setMarca] = useState();
    const [marcas, setMarcas] = useState([]);
    const [error, setError] = useState("");
    const [cargando, setCargando] = useState(false);

    const { register, handleSubmit, formState: { errors }, reset, control, watch, setValue, getValues } = useForm({
        defaultValues : {
            precio_x_bulto : 1,
            cantidad_x_bulto : 1,
            precio_unitario: "",
            marca_id : params.get('marca')
        }
    });

    useEffect(() => {
        setCargando(true);
        getMarcas()
            .then((resp) => {
                if (resp.error) {
                    setError(resp.message);
                } else {
                    setMarcas(resp.data);
                    if (id) {
                        iniciarEdicion();
                    }
                }
                setCargando(false);
            });
    }, [])

    const precio_unitario = watch('precio_unitario')
    const cantidad_x_bulto = watch('cantidad_x_bulto')

    useEffect (() => {
        const precio_x_bulto = parseFloat(precio_unitario || 0) * parseInt(cantidad_x_bulto || 0);
        setValue('precio_x_bulto', precio_x_bulto.toFixed(2)); // Actualizar el campo 'total'
    }, [cantidad_x_bulto, precio_unitario, setValue])


    //useEffect(() => {
        const iniciarEdicion = async () => {
            let resp = await getProducto(id);
            if (resp.error) {
                setErrores([resp.message]);
            } else {
                reset(resp.data);
            }
        }
    /*    if (id) {
            iniciarEdicion();
        }
    }, [id,reset])*/

    function beforeSubmit() {
        setErrores([]);
    }

    const onSubmit = async (data) => {
        setCargando(true);
        setErrores([]);
        let resp;
        if (id) {
            resp = await editarProducto(id, data);
        } else {
            resp = await nuevoProducto(data);
        }
        setCargando(false);
        if (resp.error) {
            setErrores(resp.messages);
            window.scrollTo(0,0);
            /*for (let i=0;i<resp.messages.length;i++) {
                alert(resp.messages[i]);
            }*/
        } else {
            //setError("");
            id ? alert("Producto modificado correctamente")
            : alert("Producto guardado correctamente");
            volver();
        }
    }

    function volver() {
        const url = ("/productos?marca=" + document.getElementById("marca_id").value)
        navigate(url);
    }

    return <>
        {
            id ? <BreadcrumbDatos active="Productos - Edición"/>
            : <BreadcrumbDatos active="Productos - Nuevo"/>
        }
        <ErrorMessages mensajes={errores} />
        <Form onSubmit={handleSubmit(onSubmit)}>
            <Form.Group as={Row} className="mb-3">
                <Form.Label column sm="2">
                    Código
                </Form.Label>
                <Col sm="4">
                    <Form.Control 
                        id="codigo"
                        
                        {...register("codigo", {
                            required:true, 
                            maxLength:30,
                            /* pattern : {
                                value: /^[a-zA-Z0-9]+$/, // Expresión regular para caracteres alfanuméricos sin espacios
                                message: "Solo se permiten caracteres alfanuméricos sin espacios"
                            } */
                        })} 
                        type="string"
                        htmlSize="30"
                    />
                </Col>
                {errors.codigo?.type === 'required' && <Col className="validacion error"><p role="alert">Código es requerido.</p></Col>}
                {errors.codigo?.type === 'maxLength' && <Col className="validacion error"><p role="alert">Máximo 30 caracteres.</p></Col>}
                {errors.codigo?.type === 'pattern' && <Col className="validacion error"><p role="alert">{errors.codigo.message}</p></Col>}
            </Form.Group>
            <Form.Group as={Row} className="mb-3">
                <Form.Label column sm="2">
                    Descripción
                </Form.Label>
                <Col sm="8">
                    <Form.Control 
                        id="descripcion" 
                        {...register("descripcion", {required:true, maxLength:100})}
                        type="text" />
                </Col>
                {errors.descripcion?.type === 'required' && <Col className="validacion error"><p role="alert">Descripción es requerido.</p></Col>}
                {errors.descripcion?.type === 'maxLength' && <Col className="validacion error"><p role="alert">Sólo 100 caracteres para descripción.</p></Col>}
            </Form.Group>
            <Form.Group as={Row} className="mb-3">
                <Form.Label htmlFor="selMarca" column sm="2">
                    Marca
                </Form.Label>
                <Col sm="8" >
                    <Form.Select
                        id="marca_id" 
                        value={marca_id ?? params.get('marca')}
                        defaultValue={marca_id}
                        name="marca_id"
                        {...register("marca_id", {required: true})}
                        disabled
                        onChange={(e) => {setMarca(e.target.value);/*buscar(true)*/}
                    }>
                        <option value="">Seleccione marca...</option>
                        {marcas.map((m) => <option key={m.marca_id} value={m.marca_id}>{m.nombre}</option>)}
                    </Form.Select>
                </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3">
                <Form.Label column sm="2">
                    Precio Unitario
                </Form.Label>
                <Col sm="3">
                    <Form.Control 
                        id="precio_unitario"
                        step="0.01"
                        {...register("precio_unitario", {
                            required: true,
                            min: 0.0,
                            pattern: {
                                value: /^\d+(\.\d{1,2})?$/,
                                message: 'El valor debe tener hasta 2 cifras decimales'
                            }
                        })}
                        type="number" />
                </Col>
                {
                    errors.precio_unitario?.type === 'min' && 
                    <Col className="validacion error">
                        <p role="alert">Precio Mínimo 0.1</p>
                    </Col>
                } {
                    errors.precio_unitario?.type === 'required' && 
                    <Col className="validacion error">
                        <p role="alert">El precio es requerido</p>
                    </Col>
                } {
                    errors.precio_unitario?.type === "pattern" && 
                    <Col className="validacion error">
                        <p>{errors.precio_unitario?.message}</p>
                    </Col>
                }
            </Form.Group>

            <Form.Group as={Row} className="mb-3">
                <Form.Label column sm="2">
                    Cantidad x Bulto
                </Form.Label>
                <Col sm="3">
                    <Form.Control 
                        id="cantidad_x_bulto"
                        defaultValue={1}
                        {...register("cantidad_x_bulto", {
                            required: true,
                            min: 1,
                            maxLength:5,
                            pattern: {
                                value: /^\d+(\.\d{0,0})?$/,
                                message: 'El valor debe no debe tener cifras decimales'
                            }
                        })}
                        type="number"
                    />
                </Col>
                {
                    errors.cantidad_x_bulto?.type === 'maxLength' && 
                    <Col className="validacion error">
                        <p role="alert">Máximo 5 dígitos.</p>
                    </Col>
                } {
                    errors.cantidad_x_bulto?.type === 'required' && 
                    <Col className="validacion error">
                        <p role="alert">La cantidad x bulto es requerida</p>
                    </Col>
                } {
                    errors.cantidad_x_bulto?.type === "pattern" && 
                    <Col className="validacion error">
                        <p>{errors.cantidad_x_bulto?.message}</p>
                    </Col>
                } {
                    errors.cantidad_x_bulto?.type === 'min' && 
                    <Col className="validacion error">
                        <p role="alert">Mínimo 1</p>
                    </Col>
                }
            </Form.Group>
            <Form.Group as={Row} className="mb-3">
                <Form.Label column sm="2">
                    Precio x Bulto
                </Form.Label>
                <Col sm = "3">
                    <Controller
                        name = "precio_x_bulto"
                        disabled
                        {...register('precio_x_bulto', {required : true})}
                        control={control}
                        render={({ field }) => <Form.Control  {...field} type="number" defaultValue={getValues("precio_x_bulto")}/>}
                    />
                </Col>
                {errors.precio_x_bulto?.type === "required" && 
                    <Col className="validacion error">
                        <p role="alert">El precio x bulto es requerido</p>
                    </Col> 
                }
            </Form.Group>
            {
                id ? <div>
                    <Form.Group as={Row} className="mb-3">
                        <Form.Label column sm="2">Lista de Precios</Form.Label>
                        <Col sm="8">
                            <Form.Control
                                id="lista"
                                name="nombre_lista"
                                {...register("nombre_lista")}
                                type="text"
                                disabled
                            />
                        </Col>
                    </Form.Group>
                    <Form.Group as={Row} className="mb-3">
                        <Form.Label column sm="2">Fecha de Importación</Form.Label>
                        <Col sm="3">
                            <Form.Control
                                id="fecha_importacion"
                                name="fecha_importacion"
                                {...register("fecha_importacion")}
                                type="text"
                                disabled
                            />
                        </Col>
                    </Form.Group>
                </div>
                : ""
            }
            <Form.Group as={Row} className="mb-3">
                <Form.Label column sm="2">
                    Estado
                </Form.Label>
                <Col sm="3">
                    <EstadoSelect register={register} name="estado"/>
                </Col>
            </Form.Group>
            <Form.Group as={Row} className="mb-3">
                <Col>
                    <Button onClick={beforeSubmit} type="submit">Guardar</Button>
                    <Button variant="secondary" onClick={volver}>Cancelar</Button>
                </Col>
            </Form.Group>
        </Form>
        {cargando?<Cargando></Cargando>:<></>}
    </>
}